<div class="ai-page">

  <!-- Header -->
  <div class="ai-header">
    <div class="ai-header__left">
      <div class="ai-header__icon"><mat-icon>cloud_upload</mat-icon></div>
      <div>
        <h1 class="ai-header__title">Importación contable</h1>
        <p class="ai-header__sub">Importa saldos iniciales, facturas emitidas y recibidas desde Excel</p>
      </div>
    </div>
  </div>


  <!-- Sección 1: Sumas y Saldos -->
  <div class="ai-card">
    <div class="ai-card__head">
      <div class="ai-card__icon"><mat-icon>insert_chart</mat-icon></div>
      <div>
        <h2 class="ai-card__title">Balance de Sumas y Saldos</h2>
        <p class="ai-card__sub">Importa los saldos acumulados desde otro programa contable</p>
      </div>
    </div>

    <div class="ai-steps">
      <div class="ai-step">
        <div class="ai-step__num">1</div>
        <div>
          <strong>Descarga el Excel</strong> — El sistema genera un archivo con todas tus cuentas auxiliares
          (clientes, proveedores, bancos, préstamos, inversiones, etc.) creadas previamente en
          <strong class="ai-brand">Handly</strong>.
        </div>
      </div>
      <div class="ai-step">
        <div class="ai-step__num">2</div>
        <div>
          <strong>Rellena los saldos</strong> — Introduce en el archivo el saldo deudor o acreedor final de cada
          cuenta, según tu programa contable anterior.
        </div>
      </div>
      <div class="ai-step">
        <div class="ai-step__num">3</div>
        <div>
          <strong>Respeta los signos</strong> — Importes en el <strong class="ai-must">Debe</strong> con signo
          <strong>positivo (+)</strong>; importes en el <strong class="ai-must">Haber</strong> con signo
          <strong>negativo (-)</strong>.
        </div>
      </div>
      <div class="ai-step">
        <div class="ai-step__num">4</div>
        <div>
          Se crearán <strong>asientos contables manuales</strong>. Una vez finalizado el proceso podrás
          editarlos desde el diario.
        </div>
      </div>
    </div>

    <div class="ai-card__actions">
      <button mat-flat-button class="ai-btn-primary" (click)="downloadExcel()">
        <mat-icon>file_download</mat-icon> Descargar plantilla
      </button>
      <button mat-stroked-button class="ai-btn-secondary" (click)="importSumasSaldos()">
        <mat-icon>file_upload</mat-icon> Importar Excel
      </button>
    </div>
  </div>

  <!-- Sección 2: Facturas — diferida hasta que entre en el viewport -->
  @defer (on viewport) {
  <div class="ai-card">
    <div class="ai-card__head">
      <div class="ai-card__icon ai-card__icon--blue"><mat-icon>description</mat-icon></div>
      <div>
        <h2 class="ai-card__title">Facturas Emitidas y Recibidas</h2>
        <p class="ai-card__sub">Importa el libro de facturas desde la plantilla Excel</p>
      </div>
    </div>

    <div class="ai-info-list">
      <div class="ai-info-item">
        Para importar facturas emitidas, no debe haber ninguna factura creada en <strong class="ai-brand">Handly</strong>.
      </div>
      <div class="ai-info-item">
        La plantilla incluye la leyenda de impuestos. Usa la terminación exacta; en caso contrario el proceso no continuará.
      </div>
      <div class="ai-info-item">
        Las <strong>Facturas Emitidas</strong> deben estar ordenadas por <strong>fecha de emisión</strong>.
      </div>
      <div class="ai-info-item">
        Las facturas deben pertenecer al <strong>Año Fiscal</strong> seleccionado en la barra superior.
      </div>
      <div class="ai-info-item">
        Ten en cuenta las <strong>Actividades</strong> a las que pertenecen las facturas y selecciona (o crea) la correspondiente.
      </div>
      <div class="ai-info-item">
        Crea tus <strong>cuentas bancarias</strong> y <strong>cajas</strong> antes de importar.
      </div>
      <div class="ai-info-item ai-info-item--link">
        <mat-icon>file_download</mat-icon>
        Plantillas: &nbsp;
        <a href="/assets/templates/plantilla_facturas_emitidas.xlsx">Facturas Emitidas</a>
        &nbsp;&middot;&nbsp;
        <a href="/assets/templates/plantilla_facturas_recibidas.xlsx">Facturas Recibidas</a>
      </div>
    </div>

    <div class="ai-upload-row">
      <app-select class="ai-select-field" [(ngModel)]="selectedOption"
        [config]="{ label: 'Tipo de factura', options: tipoFacturaOptions }">
      </app-select>

      <label class="ai-file-label">
        <mat-icon>attach_file</mat-icon>
        <span>{{ fileSelected ? 'Archivo seleccionado' : 'Seleccionar Excel' }}</span>
        <input type="file" (change)="fileChange($event)" accept=".xlsx" class="ai-file-input">
      </label>

      <button mat-flat-button class="ai-btn-primary" (click)="onImportClick()">
        <mat-icon>visibility</mat-icon> Previsualizar
      </button>
    </div>

    <!-- Errores -->
    <div class="ai-error-box" *ngIf="error">
      <mat-icon>warning</mat-icon>
      <div>
        <strong>Errores en el Excel. Comprueba los campos:</strong>
        <ul class="ai-error-list">
          <li *ngFor="let err of errorList; trackBy: trackByIndex">{{ err }}</li>
        </ul>
      </div>
    </div>

    <!-- Tabla Emitidas -->
    <ng-container *ngIf="emitidas">
      <div class="ai-table-wrap">
        <table class="ai-table">
          <thead>
            <tr>
              <th class="ai-th">Cliente</th>
              <th class="ai-th">País</th>
              <th class="ai-th">Provincia</th>
              <th class="ai-th">CIF</th>
              <th class="ai-th">Fecha</th>
              <th class="ai-th">Vencimiento</th>
              <th class="ai-th">Cta. contable</th>
              <th class="ai-th">Cobro</th>
              <th class="ai-th">IBAN/Caja</th>
              <th class="ai-th">Concepto</th>
              <th class="ai-th ai-th--num">Base</th>
              <th class="ai-th ai-th--num">Imp.1</th>
              <th class="ai-th ai-th--num">Imp.2</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of dataSourceEmitidas; let i = index; trackBy: trackByIndex" [class.ai-row--even]="i % 2 === 0">
              <td class="ai-td">{{ data.nombreCliente }}</td>
              <td class="ai-td">{{ data.pais }}</td>
              <td class="ai-td">{{ data.provincia }}</td>
              <td class="ai-td">{{ data.cif }}</td>
              <td class="ai-td"><span *ngIf="data.fechaFactura && data.fechaFactura !== '0001-01-01T00:00:00'">{{ data.fechaFactura | date }}</span></td>
              <td class="ai-td"><span *ngIf="data.vencimiento && data.vencimiento !== '0001-01-01T00:00:00'">{{ data.vencimiento | date }}</span></td>
              <td class="ai-td">{{ data.cuentaContable }}</td>
              <td class="ai-td">{{ data.tipoDeCobro }}</td>
              <td class="ai-td">{{ data.cuentaEfectivo }}</td>
              <td class="ai-td">{{ data.concepto }}</td>
              <td class="ai-td ai-td--num">{{ data.base }}</td>
              <td class="ai-td ai-td--num">{{ data.impuesto1 }}</td>
              <td class="ai-td ai-td--num">{{ data.impuesto2 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <!-- Tabla Recibidas -->
    <ng-container *ngIf="recibidas">
      <div class="ai-table-wrap">
        <table class="ai-table">
          <thead>
            <tr>
              <th class="ai-th">Emisor</th>
              <th class="ai-th">País</th>
              <th class="ai-th">Provincia</th>
              <th class="ai-th">CIF</th>
              <th class="ai-th">Fecha</th>
              <th class="ai-th">Nº Factura</th>
              <th class="ai-th ai-th--num">Base</th>
              <th class="ai-th ai-th--num">Imp.1</th>
              <th class="ai-th ai-th--num">Imp.2</th>
              <th class="ai-th ai-th--num">Total</th>
              <th class="ai-th">Cta. Contable</th>
              <th class="ai-th">Fecha Pago</th>
              <th class="ai-th">Forma</th>
              <th class="ai-th">IBAN/Caja</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of dataSourceRecibidas; let i = index; trackBy: trackByIndex" [class.ai-row--even]="i % 2 === 0">
              <td class="ai-td">{{ data.emisor }}</td>
              <td class="ai-td">{{ data.pais }}</td>
              <td class="ai-td">{{ data.provincia }}</td>
              <td class="ai-td">{{ data.cif }}</td>
              <td class="ai-td"><span *ngIf="data.fechaFactura && data.fechaFactura !== '0001-01-01T00:00:00'">{{ data.fechaFactura | date }}</span></td>
              <td class="ai-td">{{ data.numeroFactura }}</td>
              <td class="ai-td ai-td--num">{{ data.base }}</td>
              <td class="ai-td ai-td--num">{{ data.impuesto1 }}</td>
              <td class="ai-td ai-td--num">{{ data.impuesto2 }}</td>
              <td class="ai-td ai-td--num">{{ data.total }}</td>
              <td class="ai-td">{{ data.cuentaContable }}</td>
              <td class="ai-td"><span *ngIf="data.fechaPago && data.fechaPago !== '0001-01-01T00:00:00'">{{ data.fechaPago | date }}</span></td>
              <td class="ai-td">{{ data.forma }}</td>
              <td class="ai-td">{{ data.cajaCuenta }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <!-- Progreso -->
    <ng-container *ngIf="progress > 0">
      <div class="ai-progress-wrap">
        <div class="ai-progress-label">Importando… {{ progress }}%</div>
        <div class="ai-progress-bar">
          <div class="ai-progress-fill" [style.width.%]="progress"></div>
        </div>
        <div class="ai-done-msg" *ngIf="importDone">
          <mat-icon>check_circle</mat-icon> Facturas importadas correctamente.
        </div>
      </div>
    </ng-container>

    <div class="ai-card__actions" *ngIf="done">
      <button mat-flat-button class="ai-btn-primary" [disabled]="progress > 0 && progress < 100" (click)="start()">
        <mat-icon>cloud_upload</mat-icon> Importar libro
      </button>
    </div>

  </div>
  } @placeholder {
    <div class="ai-card ai-card--placeholder">
      <div class="ai-card__head">
        <div class="ai-card__icon ai-card__icon--blue"><mat-icon>description</mat-icon></div>
        <div>
          <h2 class="ai-card__title">Facturas Emitidas y Recibidas</h2>
          <p class="ai-card__sub">Importa el libro de facturas desde la plantilla Excel</p>
        </div>
      </div>
    </div>
  }

</div>
